import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { LeadForm } from "./LeadForm";
import { trackEvent } from "../analytics";

const FLAG = "ae_popup";

export const LeadPopup = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        let t;
        if (!sessionStorage.getItem(FLAG)) {
            t = setTimeout(() => {
                setOpen(true);
                sessionStorage.setItem(FLAG, "1");
                trackEvent("popup_open", { trigger: "timer_30s" });
            }, 30000);
        }
        return () => clearTimeout(t);
    }, []);

    useEffect(() => {
        const handler = () => {
            setOpen(true);
            sessionStorage.setItem(FLAG, "1");
            trackEvent("popup_open", { trigger: "cta" });
        };
        window.addEventListener("ae:enquire", handler);
        return () => window.removeEventListener("ae:enquire", handler);
    }, []);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/55 p-4" role="dialog" aria-modal="true" aria-label="Enquiry" data-testid="lead-popup">
            <div className="relative w-full max-w-md bg-[#f7f4ec] shadow-2xl">
                <button
                    onClick={() => setOpen(false)}
                    className="absolute right-3 top-3 z-10 p-1.5 text-[#55534a] hover:text-black"
                    aria-label="Close popup"
                    data-testid="lead-popup-close-button"
                >
                    <X size={20} />
                </button>
                <div className="border-b border-[#ded8c6] px-6 pb-4 pt-6">
                    <p className="font-display text-2xl font-semibold leading-snug text-[#23231f]">
                        Interested in Atlanta Enclave Shilphata?
                    </p>
                    <p className="mt-1.5 text-sm text-[#55534a]">
                        Get the latest price, floor plans and availability.
                    </p>
                </div>
                <div className="p-5">
                    <LeadForm source="popup_30s" idPrefix="popup" />
                </div>
            </div>
        </div>
    );
};
